import React from 'react';
import {Stack} from '@mui/system';
import {
  Body,
  designSystemToken,
  Headline,
  Icon,
  Label,
} from '@lightricks/react-design-system';
import {FeatureName} from '@contentlab/types/project';
import generateBestPracticesTooltipContent from '@contentlab/utils/generateBestPracticesTooltipContent';

function TooltipItem({
  title,
  description,
}: {
  title: string;
  description: string;
}) {
  return (
    <Stack
      direction="row"
      gap="8px"
      bgcolor={designSystemToken('semantic.bg.tertiary')}
      borderRadius="8px"
      padding="12px"
      marginBottom="8px"
    >
      <Icon
        name="Actions-Accept-Small"
        size="medium"
        appearance="neutral"
        color={designSystemToken('semantic.bg.inverse')}
      />
      <Stack gap="4px" marginTop="4px">
        <Label size="md">{title}</Label>
        <Body size="sm" sx={{fontWeight: 500}}>
          {description}
        </Body>
      </Stack>
    </Stack>
  );
}

function BestPracticesTooltip({
  onClose,
  onImageLoad,
  feature,
}: {
  onClose: () => void;
  onImageLoad: () => void;
  feature: FeatureName;
}) {
  if (!feature) {
    return null;
  }

  const {headline, image, items} = generateBestPracticesTooltipContent(feature);

  return (
    <Stack onClick={(e) => e.stopPropagation()} padding="6px 4px">
      <Stack direction="row" justifyContent="space-between" alignItems="center">
        <Headline size="xs">{headline}</Headline>
        <Stack
          justifyContent="center"
          alignItems="center"
          sx={{cursor: 'pointer'}}
          onClick={onClose}
        >
          <Icon name="Actions-Close-Small" size="medium" appearance="neutral" />
        </Stack>
      </Stack>
      <img
        src={image}
        alt="Best Practices Tooltip"
        style={{
          marginTop: '16px',
          marginBottom: '16px',
          borderRadius: '12px',
          height: '147px',
        }}
        onLoad={onImageLoad}
      />
      {items.map((item) => (
        <TooltipItem
          key={item.title}
          title={item.title}
          description={item.description}
        />
      ))}
    </Stack>
  );
}

export default BestPracticesTooltip;
